export default __webpack_public_path__ + "static/media/esrb-update.2259dad9.png";